import React, {useState, useEffect} from 'react';
import {withRouter, useParams} from "react-router-dom";
import {connect} from "react-redux";
import {
  coursePeriods,
  formatErrors, menuOptionForControl,
  months,
  stepDayTodayForControl,
  userDiseases,
  userDiseasesConfirmed
} from "../../constants";
import {toast} from "react-toastify";
import {clientControlCheckByCodeAction, clientControlSaveByCodeAction} from "../../actions/clientAction";
import '../../main.css';
import '../../responsive.css';
import {Progress} from "../../utils/progress/Progress";
import {InputInfo} from "../../utils/input/InputInfo";
import {InputCheckboxInfo} from "../../utils/checkbox/InputCheckboxInfo";
import {ConfirmModal} from "../../utils/confirm/ConfirmModal";
import {ConfirmControlModal} from "../../utils/confirm/ConfirmControlModal";

function Control(props) {
  const {code} = useParams();
  const {history, getClient} = props;
  const [item, setItem] = useState(null);
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [done, setDone] = useState(0);
  const [selfCompilationFormulas, setSelfCompilationFormulas] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const msgSuccess = "Спасибо! ваш отчет отправлен куратору и он обязательно проверит его в течение дня!";

  useEffect(() => {
    if (!code) {
      history.push('/');
    }
    getClient(code).then((data) => {
      let stage = '', stage_day = '';
      try {
        const now = new Date();
        now.setHours(0, 0, 0, 0);
        const dt_start = new Date(data.start_at);
        dt_start.setHours(0, 0, 0, 0);
        if (now >= dt_start) {
          let diff = Math.ceil((now.getTime() - dt_start.getTime()) / 1000 / 86400) + 1;
          let passed = 0;
          for (let i = 0; i < coursePeriods.length; i++) {
            if (passed + coursePeriods[i].days >= diff) {
              stage = coursePeriods[i].title;
              stage_day = '' + (diff - passed);
              break;
            }
            passed += coursePeriods[i].days;
          }
        }
      } catch (e) {
      }

      setForm({
        program_stage: stage,
        program_stage_day: stage_day,
        weight: data.item.weight || '',
        wake_up_time: data.item.wake_up_time || '',
        breakfast: data.item.breakfast || '',
        snack1: data.item.snack1 || '',
        lunch: data.item.lunch || '',
        snack2: data.item.snack2 || '',
        dinner: data.item.dinner || '',
        snack3: data.item.snack3 || '',
        water_until_15: data.item.water_until_15 || '',
        water_until_20: data.item.water_until_20 || '',
        training_yesterday: data.item.training_yesterday || '',
        defecation_yesterday: data.item.defecation_yesterday || '',
        bedtime: data.item.bedtime || '',
        step_day_today: data.item.step_day_today || '',
        stage_program_currently: data.item.stage_program_currently || '',
        menu_option: data.item.menu_option ? data.item.menu_option.split(',') : [],
        amount_fiber_eaten: data.item.amount_fiber_eaten || '',
        date_report_completed: data.item.date_report_completed || ''
      });
      setItem(true);

      if(Number(data.item.stage_program_currently) === 3 && data.item.menu_option === "Самостоятельное составление формул") {
        setSelfCompilationFormulas(true)
      }

    }).catch((err) => {
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
      history.push('/');
    });
  }, [code, history, getClient]);

  useEffect(() => {
    setDone(Object.keys(form).reduce((res, i) => {
      if (i !== 'program_stage' && i !== 'program_stage_day' && ('' + form[i]).length > 0) {
        res += 1;
      }
      return res;
    }, 0))
  }, [form]);

  const handleChangeText = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    const vals = {[name]: value};
    if (name === 'program_stage') {
      vals['program_stage_day'] = '';
    }
    if (name === 'stage_program_currently') {
      setSelfCompilationFormulas(false)
      vals['menu_option'] = [];
    }
    setForm((form) => {
      return {...form, ...vals}
    });
    if (value !== '' && errors[name]) {
      setErrors((errors) => {
        return {...errors, [name]: false}
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (loading) {
      return false;
    }
    let errs = {};
    const values = {...form};

    setErrors(errs);
    if (Object.keys(errs).length > 0) {
      return;
    }

    setLoading(true);
    props.updateClient(code, values).then(() => {
      setLoading(false);
      toast.success('Отчет сохранен', {position: toast.POSITION.BOTTOM_RIGHT});
      setOpenModal(true);
    }).catch(err => {
      setLoading(false);
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  useEffect(() => {
    document.title = 'Курс метаболического похудения';
    document.querySelector('meta[name="description"]').content = 'Анкета Контроля';
    document.body.className = "page-info";
    return () => {
      document.body.className = "";
      document.title = 'Куратор';
      document.querySelector('meta[name="description"]').content = 'Панель оператора';
    }
  }, []);

  const handleMenuOptionSelected = (item, checked) => {
    if(Number(form.stage_program_currently) === 3 && checked && item === "Самостоятельное составление формул") {
      setSelfCompilationFormulas(true)
    }else if(Number(form.stage_program_currently) === 3 && !checked && item === "Самостоятельное составление формул"){
      setSelfCompilationFormulas(false)
    }else{
      setSelfCompilationFormulas(false)
    }

    setForm((form) => {
      return {...form, menu_option: []}
    });

    setForm((form) => {
      return {...form, menu_option: checked ? [item].concat(form.menu_option) : form.menu_option.filter(i => i !== item)}
    });
  };

  const handleOpen = (value) => {
    if (loading) {
      return;
    }
    setOpenModal(value);
  };

  return <header>
    <Progress all={18} done={done}/>

    {item && <div className="container">
      <div className="info">
        <div className="info__title">
          <p className="title">Контроль</p>
          <p className="valid">* поля обязательны для заполнения</p>
        </div>
        <form className="info__form" noValidate onSubmit={handleSubmit}>

          <InputInfo type="text"
                     title="Вес сегодня"
                     name="weight"
                     value={form.weight}
                     error={errors.weight || false}
                     disabled={loading}
                     onChange={handleChangeText}/>

          <InputInfo type="time"
                     title="Время просыпания"
                     name="wake_up_time"
                     value={form.wake_up_time}
                     error={errors.wake_up_time || false}
                     disabled={loading}
                     onChange={handleChangeText}/>

          <div className="info__form_input">
            <p>На какой ступени программы вы сейчас находитесь:</p>
            <select className="" name="stage_program_currently"
                    title="На какой ступени программы вы сейчас находитесь"
                    value={form.stage_program_currently}
                    error={errors.stage_program_currently || false}
                    disabled={loading}
                    onChange={handleChangeText}>
              <option value="">Нажмите для выбора этапа</option>
              <option key={1} value={1}>Детокс</option>
              <option key={2} value={2}>Экспресс</option>
              <option key={3} value={3}>Марафон</option>
            </select>
          </div>

          {form.stage_program_currently && <div className="info__form_radio">
            <p>Выберите ваш вариант питания</p>
            <div className="check-inputs">
              {
                menuOptionForControl[form.stage_program_currently].map((i, k) => <InputCheckboxInfo key={k}
                                   title={i}
                                   disabled={loading}
                                   name={'menu_option_'+k}
                                   checked={form.menu_option.indexOf(i) > -1}
                                   onChange={(name, checked) => handleMenuOptionSelected(i, checked)}/>)
              }
            </div>
          </div>}

          <InputInfo type="text"
                     title="Какой день ступени (номер) у вас сегодня?"
                     name="step_day_today"
                     value={form.step_day_today}
                     error={errors.step_day_today || false}
                     disabled={loading}
                     onChange={handleChangeText}/>

          <InputInfo type="text"
                     title="За какое число заполнен отчет?"
                     name="date_report_completed"
                     value={form.date_report_completed}
                     error={errors.date_report_completed || false}
                     disabled={loading}
                     onChange={handleChangeText}/>

          <InputInfo type="text"
                     title="Количество съеденной клетчатки, какой (растворимой, нерастворимой)"
                     name="amount_fiber_eaten"
                     value={form.amount_fiber_eaten}
                     error={errors.amount_fiber_eaten || false}
                     disabled={loading}
                     onChange={handleChangeText}/>

          <InputInfo type="text"
                     title={"Время завтрака" + (selfCompilationFormulas ? ", формула, перечень продуктов и их вес":" и перечень продуктов и их вес")}
                     name="breakfast"
                     value={form.breakfast}
                     error={errors.breakfast || false}
                     disabled={loading}
                     onChange={handleChangeText}/>

          <InputInfo type="text"
                     title={"Время 1 перекуса" + (selfCompilationFormulas ? ", формула, перечень продуктов и их вес":" и перечень продуктов и их вес")}
                     name="snack1"
                     value={form.snack1}
                     error={errors.snack1 || false}
                     disabled={loading}
                     onChange={handleChangeText}/>

          <InputInfo type="text"
                     title={"Время обеда" + (selfCompilationFormulas ? ", формула, перечень продуктов и их вес":" и перечень продуктов и их вес")}
                     name="lunch"
                     value={form.lunch}
                     error={errors.lunch || false}
                     disabled={loading}
                     onChange={handleChangeText}/>

          <InputInfo type="text"
                     title={"Время 2 перекуса" + (selfCompilationFormulas ? ", формула, перечень продуктов и их вес":" и перечень продуктов и их вес")}
                     name="snack2"
                     value={form.snack2}
                     error={errors.snack2 || false}
                     disabled={loading}
                     onChange={handleChangeText}/>

          <InputInfo type="text"
                     title={"Время ужина" + (selfCompilationFormulas ? ", формула, перечень продуктов и их вес":" и перечень продуктов и их вес")}
                     name="dinner"
                     value={form.dinner}
                     error={errors.dinner || false}
                     disabled={loading}
                     onChange={handleChangeText}/>

          <InputInfo type="text"
                     title={"Время вечернего перекуса" + (selfCompilationFormulas ? ", формула, перечень продуктов и их вес":" и перечень продуктов и их вес (если назначено куратором)")}
                     name="snack3"
                     value={form.snack3}
                     error={errors.snack3 || false}
                     disabled={loading}
                     onChange={handleChangeText}/>

          <InputInfo type="text"
                     title="Кол-во выпитой воды до 15.00"
                     name="water_until_15"
                     value={form.water_until_15}
                     error={errors.water_until_15 || false}
                     disabled={loading}
                     onChange={handleChangeText}/>

          <InputInfo type="text"
                     title="Кол-во выпитой воды с 15.00 до 20.00"
                     name="water_until_20"
                     value={form.water_until_20}
                     error={errors.water_until_20 || false}
                     disabled={loading}
                     onChange={handleChangeText}/>

          <InputInfo type="text"
                     title="Была ли физическая тренировка вчера?"
                     name="training_yesterday"
                     value={form.training_yesterday}
                     error={errors.training_yesterday || false}
                     disabled={loading}
                     onChange={handleChangeText}/>

          <InputInfo type="text"
                     title="Был ли стул (дефекация) и сколько раз в день?"
                     name="defecation_yesterday"
                     value={form.defecation_yesterday}
                     error={errors.defecation_yesterday || false}
                     disabled={loading}
                     onChange={handleChangeText}/>

          <InputInfo type="time"
                     title="Время отбоя"
                     className="bottom"
                     name="bedtime"
                     value={form.bedtime}
                     error={errors.bedtime || false}
                     disabled={loading}
                     onChange={handleChangeText}/>

          <button type="submit" className="info__form_btn">Отправить</button>
          <ConfirmControlModal title={msgSuccess} openModal={openModal} handleOpen={handleOpen}/>
        </form>
      </div>
    </div>}
  </header>;
}

const mapDispatchToProps = (dispatch) => {
  return {
    getClient(code) {
      return dispatch(clientControlCheckByCodeAction(code));
    },
    updateClient(code, data) {
      return dispatch(clientControlSaveByCodeAction(code, data));
    }
  }
};

export default connect(null, mapDispatchToProps)(withRouter(Control))
